// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon.css
// module id = 1098
// module chunks = 42